import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';

const Global: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('powerbackup.Global');

    const descList = [
        {
            title: t('desc_title_1'),
            desc: t('desc_desc_1'),
        },
        {
            title: t('desc_title_2'),
            desc: t('desc_desc_2'),
        },
        {
            title: t('desc_title_3'),
            desc: t.rich('desc_desc_3', {
                link: (text: string) => (
                    <a className="link" href={`https://www.ecoflow.com/${locale}/x-core-3`} target="_blank">
                        {text}
                    </a>
                ),
            }),
        },
        {
            title: t('desc_title_4'),
            desc: t('desc_desc_4'),
        },
    ];

    return (
        <div
            className={`${styles['battery-backup-Global']} battery-backup-Global GtmModuleData-section`}
            id="battery-backup-Global"
            data-section-id={'battery-backup-Global'}
            data-section-title={'Global No.1'}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1749609449283/No1.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1749624287014/mobile-bg.jpg"
            />
            <div className="text-wrapper ">
                <div className="text-top page-layout">
                    <div className="text-top-title">
                        {t.rich('text_top_title', {
                            mark: (text: string) => <span className="mark">{text}</span>,
                        })}
                    </div>
                    <div className="text-top-desc">{t('text_top_desc')}</div>
                </div>
                <div className="text-bottom ">
                    <div className="text-bottom-wrap page-layout">
                        <div className="desc-box">
                            {descList.map((item, index) => (
                                <div className="desc-item" key={index}>
                                    <div className="desc-item-title">{item.title}</div>
                                    <div className="desc-item-desc">{item.desc}</div>
                                </div>
                            ))}
                        </div>
                        <div className="footer-text">{t('footer_text')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Global;
